// extracted by mini-css-extract-plugin
module.exports = {"header":"list_header__10zvR","heading":"list_heading__3cpfI"};